module.exports = __webpack_public_path__ + "img/1.8f19f21b.png";